<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7.2 9.44V3.68h1.6v5.76zM7.2 12v-1.6h1.6V12z"
    clip-rule="evenodd"
  />
  <path stroke="currentColor" stroke-width="1.33" d="M.665.665h14.67v14.67H.665z" />
</svg>
